import { Module } from "vuex";
import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { IAssessmentState } from "@/store/modules/assessment/types";
import { getters } from "@/store/modules/assessment/getters";
import { RootState } from "@/store/types";

const namespaced: boolean = true;

export const assessmentModule: Module<IAssessmentState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};
